// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"324":"00c2bbac","840":"ed05b670"}[chunkId] + ".css";
};